module.exports = __webpack_public_path__ + "img/LREXHeaderLogo.dbf15b38.jpg";